import { render, staticRenderFns } from "./ManualDosing.vue?vue&type=template&id=4f08b806&"
import script from "./ManualDosing.vue?vue&type=script&lang=js&"
export * from "./ManualDosing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports